export const EN_SPACE = ' '
